import './App.css';
import React, { Component } from 'react';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import SiteConfig from './SiteConfig';

class Main extends Component {
    get lang() { return localStorage.getItem('lang') || 'th'; }
    syncPath = () => { this.setState({ pathname: window.location.pathname.replace("/", "").trim() }); };
    // เปลี่ยนหน้าแบบ SPA: อัปเดต URL + แจ้ง Router ใน App ให้สลับ content โดยไม่ reload (ไม่กระพริบ)
    checkurl = (e, url) => {
        if (e) e.preventDefault();
        if (!url || url === window.location.pathname) { this.syncPath(); return; }
        try {
            window.history.pushState({}, "", url);
            window.dispatchEvent(new PopStateEvent("popstate"));
            this.syncPath();
            window.scrollTo(0, 0);
        } catch (err) {
            window.location.href = url;
        }
    };
    componentWillUnmount() { window.removeEventListener("popstate", this.syncPath); }
    constructor(props) {
        super(props)
        this.state = {
            pathname: "",
            linelink: ""
        }
    }
    async componentDidMount() {
        window.addEventListener("popstate", this.syncPath);
        this.setState({
            pathname: window.location.pathname.replace("/", "").trim()
        });
        await instance.post("/api/v1/mainsetting", {
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                this.setState({
                    linelink: datas[1].value
                });
            }
            else {
            }
        });
    }
    render() {
        const pathname = this.state.pathname
        const lang = this.lang;
        // ดีไซน์เดิม: title อังกฤษ + cls + path (active) เก็บใน component, ข้อมูลเมนูมาจาก SiteConfig.SidebarMenuItems
        const SB_PRES = {
            hot_game:   { title: "HOT GAME",   cls: "-hot-game",     path: "" },
            casino:     { title: "CASINO",     cls: "-casino",       path: "casino" },
            slot:       { title: "SLOT",       cls: "-slot",         path: "slot" },
            sport:      { title: "SPORT",      cls: "-sport",        path: "sport" },
            fishing:    { title: "FISHING",    cls: "-fishing-game", path: "fising" },
            skill_game: { title: "SKILL GAME", cls: "-skill-game",   path: "arcade" },
            e_sport:    { title: "E-SPORT",    cls: "-e-sport",      path: "esport" },
        };
        const items = (SiteConfig.SidebarMenuItems || []).filter((it) => it.enabled !== false).map((it) => {
            const p = SB_PRES[it.labelKey] || {};
            const label = (it.labels && (it.labels[lang] || it.labels.th)) || '';
            return { cls: p.cls || "", path: p.path || "", href: it.url, img: it.img, title: p.title || "", trans: label, mobile: label, alt: label };
        });
        return (
            <div className="x-menu-provider js-tab-menu-provider -desktop-view">
                <nav className="nav-menu" id="navbarCategory">
                    <ul className="nav nav-pills js-menu-container -nav-menu-container">
                        {items.map((it, i) => (
                            <li className="nav-item" key={i}>
                                <button
                                    className={"nav-link " + it.cls + " " + (pathname === it.path ? "active" : "")}
                                    onClick={(e) => this.checkurl(e, it.href)}
                                >
                                    <div className="-nav-link-wrapper">
                                        <img src={it.img} alt={it.alt} className="img-fluid -ic-menu" width={55} height={55} />
                                        <div className="-text-provider-wrapper" style={{ whiteSpace: 'nowrap' }}>
                                            <div className="-text-nav-menu -title">{it.title}</div>
                                            <div className="-text-nav-menu -title-trans">{it.trans}</div>
                                            <div className="-text-nav-menu -title-mobile">{it.mobile}</div>
                                        </div>
                                    </div>
                                </button>
                            </li>
                        ))}
                    </ul>
                    <div className="-contact-wrapper ">
                        <div className="x-contact-us -multiple">
                            <img src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/contact-us-multiple-cover.png" alt="" className="img-fluid -cover-img ls-is-cached lazyloaded" />
                            <div className="-btn-group-wrapper">
                                <a href={this.state.linelink} className="-link-wrapper -line-wrapper" target="_blank" rel="noopener noreferrer">
                                    <img src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/contact-us-multiple-line.png" alt="" className="img-fluid -img ls-is-cached lazyloaded" />
                                </a>
                                <a href="XXXXXXX" className="-link-wrapper -telegram-wrapper" target="_blank" rel="noopener noreferrer">
                                    <img src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/contact-us-multiple-telegram.png" alt="" className="img-fluid -img ls-is-cached lazyloaded" />
                                </a>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        );
    }
}
export default Main;
